import { render, staticRenderFns } from "./ModalReminderFrame.vue?vue&type=template&id=62a0e853&scoped=true&"
import script from "./ModalReminderFrame.vue?vue&type=script&lang=js&"
export * from "./ModalReminderFrame.vue?vue&type=script&lang=js&"
import style0 from "./ModalReminderFrame.vue?vue&type=style&index=0&id=62a0e853&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a0e853",
  null
  
)

export default component.exports